export default __webpack_public_path__ + "static/media/FOTOS_DISCO_06.b315959f.jpg";